import React from 'react'
import AppInfo from './AppInfo/test'
// import CustomValueEditor from './AppInfo/index'
import styles from './appInformation.module.sass'
import { ToastContainer } from 'react-toastify'
import {QueryBuilder, add, ActionWithRulesProps} from 'react-querybuilder'
import { useState } from 'react'
import {ReactComponent as AddButtonIcon} from '../../media/images/icons/add_meta.svg' 

const AppInformation = ({isChanged, setIsChanged}) => {

  return (
    <>
      <ToastContainer />
      <div className={styles.row}>
        <div className={styles.col}>
          <AppInfo isChanged={isChanged} setIsChanged={setIsChanged} className={styles.card}/>
        </div>
      </div>
    </>
  )
}

export default AppInformation